const getters = {
  token: state => state.user.token,
  wxtoken: state => state.wxuser.wxtoken,
  nickname: state => state.wxuser.nickname,
  avatar: state => state.wxuser.avatar,
  wxuserid: state => state.wxuser.wxuserid,
  activebar: state => state.app.activebar,
  isshowbottom: state => state.app.isshowbottom,
  beforerou: state => state.app.beforerou
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js